const basePath = document.documentElement.dataset.basepath

export default {
    basePath,
    assetFolder: `${basePath}/assets/game`,
    sceneWidth: 1920,
    sceneHeight: 1080,
    groundHeight: 174
}